// extracted by mini-css-extract-plugin
module.exports = {"list-item":"_3c6ef300a5--list-item--FN6mY","item-info":"_3c6ef300a5--item-info--i3WO8"};